import {MetaAcao} from "./meta-acao";
import {ComboMetaAcao} from "./combo-meta-acao";

export class MetaAcaoExecutada {

    id: number;
    metaAcao: MetaAcao;
    combo: ComboMetaAcao;

}